<template>
	<!-- Bruger en div som wrapper for at undgå fragment instance fejl -->
	<div>
		<section class="row">

			<header class="shop__header margin-b-50">

				<h1>Dine oplysninger</h1>

				<p>Udfylde dine adresse oplysninger, e-mail adresse og telefonnummer.</p>

			</header>

			<form class="shop-form" @submit.prevent="submitInformation">

				<div class="row">

					<section class="col-6 margin-b-25">

						<label>Hvad er dit fornavn?</label>

						<div class="input-group">

							<input type="text" placeholder="f.eks. søren" name="firstname"
								   v-model="information.firstname" @blur="enteredField('firstname')">

							<span class="checkmark" v-if="firstNameValidated">

                          <img src="/images/green-checkmark.svg" alt="Validated icon"/>

                        </span>

							<span class="checkmark" v-if="!firstNameValidated && hasEnteredFirstName">

                          <img src="/images/red-checkmark.svg" alt="Not validated icon"/>

                        </span>

						</div>

					</section>

					<section class="col-6 margin-b-25">

						<label>Hvad er dit efternavn?</label>

						<div class="input-group">

							<input type="text" placeholder="f.eks. hansen" name="lastname"
								   v-model="information.lastname" @blur="enteredField('lastname')">

							<span class="checkmark" v-if="lastNameValidated">

                          <img src="/images/green-checkmark.svg" alt="Validated icon"/>

                        </span>

							<span class="checkmark" v-if="!lastNameValidated && hasEnteredLastName">

                          <img src="/images/red-checkmark.svg" alt="Not validated icon"/>

                        </span>

						</div>

					</section>

				</div>

				<div class="row margin-b-25">

					<label>Hvad er din adresse?</label>

					<div class="input-group">

						<input type="text" placeholder="f.eks. kanalvej 52" name="address" v-model="information.address"
							   @blur="enteredField('address')">

						<span class="checkmark" v-if="addressValidated">

                        <img src="/images/green-checkmark.svg" alt="Validated icon"/>

                      </span>

						<span class="checkmark" v-if="!addressValidated && hasEnteredAddress">

                        <img src="/images/red-checkmark.svg" alt="Not validated icon"/>

                      </span>

					</div>

				</div>

				<div class="row">

					<section class="col-6 margin-b-25">

						<label>Hvad er dit postnummer?</label>

						<div class="input-group">

							<input class="col-12" type="tel" placeholder="f.eks. 5000" name="zipcode" id="zipcode"
								   min="1000" max="9999" maxlength="4" v-model="information.zipcode"
								   @blur="getCityForZipCode">

							<span class="checkmark" v-if="zipCodeValidated">

                        <img src="/images/green-checkmark.svg" alt="Validated icon"/>

                      </span>

							<span class="checkmark" v-if="!zipCodeValidated && hasEnteredZip">

                        <img src="/images/red-checkmark.svg" alt="Not validated icon"/>

                      </span>

						</div>

					</section>

					<section class="col-6 margin-b-25">

						<label>Hvilken by bor du i?</label>

						<div class="input-group">

							<input type="text" placeholder="f.eks. odense c" name="city" v-model="city"
								   @blur="updateInformationWithCity">

							<span class="checkmark" v-if="cityValidated">

                          <img src="/images/green-checkmark.svg" alt="Validated icon"/>

                        </span>

							<span class="checkmark" v-if="!cityValidated && hasEnteredCity">

                          <img src="/images/red-checkmark.svg" alt="Not validated icon"/>

                        </span>

						</div>

					</section>

				</div>

				<div class="row">

					<section class="col-6 margin-b-25">

						<label>Hvad er din e-mail adresse?</label>

						<div class="input-group">

							<input type="email" placeholder="f.eks. ole@hansen.dk" name="email"
								   v-model="information.email" @blur="enteredField('email')">

							<span class="checkmark" v-if="emailValidated">

                        <img src="/images/green-checkmark.svg" alt="Validated icon"/>

                      </span>

							<span class="checkmark" v-if="!emailValidated && hasEnteredEmail">

                        <img src="/images/red-checkmark.svg" alt="Not validated icon"/>

                      </span>

						</div>

					</section>

					<section class="col-6 margin-b-25">

						<label>Hvad er dit telefonummer?</label>

						<div class="input-group">

							<input class="col-12" type="number" placeholder="f.eks. 62717181" name="phone"
								   v-model="information.phone" @blur="enteredField('phone')">

							<span class="checkmark" v-if="phoneValidated">

                            <img src="/images/green-checkmark.svg" alt="Validated icon"/>

                          </span>

							<span class="checkmark" v-if="!phoneValidated && hasEnteredPhone">

                            <img src="/images/red-checkmark.svg" alt="Not validated icon"/>

                          </span>

						</div>

					</section>

				</div>

				<div class="row">

					<header class="shop__header margin-tb-50">

						<h1>Bemærkninger</h1>

						<p>Der kan <strong>IKKE</strong> ændres i menuerne, ej heller i forhold til allergier.</p>

					</header>

					<div class="col-12">

						<label>Har du evt. bemærkninger?</label>

						<textarea class="col-12" placeholder="f.eks. tilkøb til en eksisterende ordre" name="comment"
								  v-model="information.comment"></textarea>

					</div>

				</div>



				<div class="row border-t padding-tb-50">

					<a class="margin-t-15 pull-left" href="#" @click.prevent="goBack">Gå tilbage</a>

					<button class="btn--primary pull-right" type="submit" id="submit" name="submit"
							:class="{'disabled':(!allInformationValidated || isLoading)}"
							:disabled="isLoading && !allInformationValidated">

                        <span>

                          <i class="spinner--light" v-if="isLoading"></i>

                          {{submitLabel}}

                        </span>

					</button>

				</div>

			</form>

		</section>

	</div>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        data: function () {
            return {
                city: '',
                isLoading: false,
				enteredFields: [],
            }
        },
        computed: {
            ...mapGetters({storeInformation: 'getInformation'}),
            information: {
                cache: false,
                get() {
                    return this.storeInformation;
                },
                set(value) {
                    this.setInformation(value);
                }
            },
            submitLabel() {
                return (this.isLoading) ? 'Bearbejder Oplysninger' : 'Gå til Bekræftelse';
            },
            firstNameValidated() {
                if (this.information.firstname) {
                    return this.information.firstname !== '' && this.information.firstname.length > 0;
                }

                return false;
            },
            lastNameValidated() {
                if (this.information.lastname) {
                    return this.information.lastname !== '' && this.information.lastname.length > 0;
                }

                return false;
            },
            addressValidated() {
                if (this.information.address) {
                    var addressRegex = this.information.address.match(/([A-Z])\w*\s+([0-9])+/gi);

                    return this.information.address !== '' && (addressRegex instanceof Array && addressRegex.length > 0);
                }

                return false;
            },
            zipCodeValidated() {
                if (this.information.zipcode) {

                    var zipcodeRegex = String(this.information.zipcode).match(/^([0-9]){4,4}/gi);

                    return this.information.zipcode !== '' && (zipcodeRegex instanceof Array && zipcodeRegex.length > 0 && zipcodeRegex.length < 5);
                }

                return false;
            },
            cityValidated() {
                return this.city !== '';
            },
            emailValidated() {
                if (this.information.email) {
                    var emailRegex = this.information.email.match(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i);
                    return this.information.email !== '' && (emailRegex instanceof Array && emailRegex.length > 0);
                }

                return false;
            },
            phoneValidated() {
                if (this.information.phone) {
                    var phoneRegex = String(this.information.phone).match(/^([0-9]){8,8}/gi);

                    return this.information.phone !== '' && (phoneRegex instanceof Array && phoneRegex.length > 0);
                }
            },
            cardType() {
                return (this.currentCard != 'unknown' && this.currentCard != '') ? this.cardImages[this.currentCard] : false;
            },
            allInformationValidated() {
                return this.firstNameValidated
                    && this.lastNameValidated
                    && this.addressValidated
                    && this.zipCodeValidated
                    && this.cityValidated
                    && this.emailValidated
                    && this.phoneValidated;
            },
            hasEnteredFirstName() {
                return this.fieldHasBeenEntered('firstname');
            },
            hasEnteredLastName() {
                return this.fieldHasBeenEntered('lastname');
            },
            hasEnteredAddress() {
                return this.fieldHasBeenEntered('address');
            },
            hasEnteredZip() {
                return this.fieldHasBeenEntered('zip');
            },
            hasEnteredCity() {
                return this.fieldHasBeenEntered('city');
            },
            hasEnteredEmail() {
                return this.fieldHasBeenEntered('email');
            },
            hasEnteredPhone() {
                return this.fieldHasBeenEntered('phone');
            },
        },
        methods: {
            ...mapActions(['setStep', 'setInformation']),
            submitInformation() {

                if (this.allInformationValidated) {
					this.$ua.trackEvent('Link', 'Click', 'Shop - Step 2 - Informations');
					this.setStep(2);
                }

            },
            getCityForZipCode() {
                this.enteredField('zip');

                let axiosInstance = axios.create();
                axiosInstance.defaults.headers.common = {};

                axiosInstance.get(`https://dawa.aws.dk/postnumre?nr=${this.information.zipcode}`).then((response) => {
                    if (response.data.length > 0) {
                        var city = response.data[0].navn;
                        this.city = city;
                        this.information.city = city;
                    }
                }).catch((response) => {
                    console.log(response);
                });


            },
            updateInformationWithCity() {
                this.enteredField('city');
                if(this.city != this.information.city){
                    this.information.city = this.city;
				}
            },
            fieldHasBeenEntered(fieldName) {
                return this.enteredFields.indexOf(fieldName) > -1
            },
            enteredField(fieldName) {
                if (!this.fieldHasBeenEntered(fieldName)) {
                    return this.enteredFields.push(fieldName);
                }
            },
            limitZip() {
                if (this.information.zipcode.length > 4) {
                    this.information.zipcode = this.information.zipcode.substring(0, 4);
                }
            },
            goBack() {
                if (!this.isLoading) {
                    this.setStep(0);
                }
            },
        },
		mounted() {
			if (this.storeInformation.city) {
				this.city = this.storeInformation.city;
			}
		}
	}
</script>
